// src/config/stripePlans.js

export const STRIPE_PLANS = {
  vendor: {
    monthly: {
      label:           'Vendor Premium',
      price:           '$20',
      interval:        'month',
      plan_type:       'vendor_monthly',
      stripe_price_id: 'price_1TGmeB2X5NAIUdz4lqJkUUR8',  
      paymentLink:     'https://buy.stripe.com/test_cNi9AMbW55o2aUa20g7e00',
    },
    yearly: {
      label:           'Vendor Premium',
      price:           '$200',
      interval:        'year',
      saving:          'Save $40',
      plan_type:       'vendor_yearly',
      stripe_price_id: 'price_1TGmxe2X5NAIUdz45VsF5Qxo',  
      paymentLink:     'https://buy.stripe.com/test_3cI5kw2lv7w83eY0rqg7e01',
    },
  },
  organization: {
    monthly: {
      label:           'Organisation Premium',
      price:           '$20',
      interval:        'month',
      plan_type:       'organization_monthly',
      stripe_price_id: 'price_1TGn3F2X5NAIUdz4iF5mF74d',  
      paymentLink:     'https://buy.stripe.com/test_4gMeV67FP03G02M4HGg7e02',
    },
    yearly: {
      label:           'Organisation Premium',
      price:           '$200',
      interval:        'year',
      saving:          'Save $40',
      plan_type:       'organization_yearly',
      stripe_price_id: 'price_1TGn5O2X5NAIUdz48LbZ2czw', 
      paymentLink:     'https://buy.stripe.com/test_3cI4gs7FP03G6rab64g7e03',
    },
  },
};